import Application from "../../Application";
import FormConfigurationPresenter, {
  IFormConfigurationPresenter
} from "../../presenter/formconfiguration/FormConfigurationPresenter";
import ShowErrorMessageInteractor from "../notifications/ShowErrorMessageInteractor";
import { IFormType } from "../../model/formconfiguration/FormType";
import GetFormConfigDetailsInteractor from "./GetFormConfigDetailsInteractor";

export default class ShowFormConfigurationInteractor {
  private application: Application;
  private output?: IFormConfigurationPresenter;

  constructor(application) {
    this.application = application;
  }

  async getFormDetails(formTypeCode: string) {
    try {
      const formConfigurationDetails = await this.application.container
        .resolve<GetFormConfigDetailsInteractor>("getFormConfigDetails")
        .execute(formTypeCode);

      return formConfigurationDetails;
    } catch (error) {
      this.application.container
        .resolve<ShowErrorMessageInteractor>("showError")
        .execute((error as any).message);
    }
  }

  execute(formTypeCode: string) {
    this.output = FormConfigurationPresenter({
      application: this.application,
      initialState: {
        formSections: [],
        formType: {} as IFormType,
        selectedFormElement: undefined,
        qualifiers: [],
        attributes: [],
        formParamsBoxVisible: false
      }
    });

    this.getFormDetails(formTypeCode).then(
      (result) =>
        result &&
        this.output &&
        this.output.loadFormDetails(
          result.formType,
          result.formSections,
          result.qualifiers,
          result.attributes
        )
    );

    return this.output;
  }
}
